export enum ResolutionStatus {
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  UNRESOLVED = 'unresolved',
}

export type SuggestionAction = 'accept' | 'reject';
